import api from '../../utils/api'
import { useState, useEffect, useMemo } from "react"
import { FiInbox } from 'react-icons/fi'

import Input from "../../shared/components/form/input"
import ListSystemUserRow from './ListRow/ListSystemUserRow'
import Modal from '../../shared/modal/Modal'
import NewSystemUser from './NewSystemUser'
import Button from '../../shared/components/Button/Button'
import './ListSystemUser.css'

function ListSystemUser() {

    const [token] = useState(localStorage.getItem('token') || '')
    const [users, setUsers] = useState([])
    const [myPermission, setMyPermission] = useState({ group: "" })
    const [modalNew, setModalNew] = useState(false)
    const [search, setSearch] = useState("")
    const [load, setLoad] = useState(false)

    const getAll = () => {
        api.get('/user/getall', {
            headers: { Authorization: `Bearer ${JSON.parse(token)}` },
        }).then((response) => {
            setUsers(response.data.users)
            setMyPermission(response.data.permission)
            setLoad(true)
        })
    }

    useEffect(() => { getAll() }, [token])

    const filter = useMemo(() => {
        const searchLowerCase = search.toLowerCase()
        return users.filter((item) => (item.name || '').toLowerCase().includes(searchLowerCase))
    }, [users, search])

    const myPermissionView = myPermission.group === "DEV_MASTER" || myPermission.group === "ADM_USER"

    if (!load) {
        return <div className="pg-loading">Carregando usuários...</div>
    }

    return myPermissionView ? (
        <section className="pg-page">

            <div className="pg-sticky-top">
                <div className="pg-header">
                    <div className="pg-header-title">
                        <p className="pg-title">Usuários do Sistema</p>
                        <span className="pg-title-accent" />
                    </div>
                    <div className="pg-header-row">
                        <div className="pg-header-actions">
                            <Button variant="new" onClick={() => setModalNew(true)}>Cadastrar</Button>
                        </div>
                        <div className="pg-header-right">
                            <div className="pg-search">
                                <Input
                                    type="text"
                                    name="search"
                                    placeholder="Buscar usuário..."
                                    value={search}
                                    handleOnChange={(e) => setSearch(e.target.value)}
                                />
                            </div>
                            <span className="pg-count">
                                {filter.length} {filter.length === 1 ? 'usuário' : 'usuários'}
                            </span>
                        </div>
                    </div>
                </div>
            </div>

            <div className="pg-list">
                {filter.length > 0 ? (
                    <ListSystemUserRow dataArray={filter} handleOnSuccess={getAll} />
                ) : (
                    <div className="pg-empty">
                        <FiInbox size={32} className="pg-empty-icon" />
                        <p className="pg-empty-title">Nenhum usuário encontrado</p>
                        <p className="pg-empty-subtitle">
                            {users.length === 0
                                ? 'Cadastre o primeiro usuário para começar.'
                                : 'Tente ajustar a busca.'}
                        </p>
                    </div>
                )}
            </div>

            <Modal
                modalStatus={modalNew}
                changeStatus={setModalNew}
                w={80}
                content={
                    <NewSystemUser
                        btCancelAction={() => setModalNew(false)}
                        handleOnSuccess={() => { setModalNew(false); getAll() }}
                    />
                }
            />

        </section>
    ) : (
        <div className="pg-empty">
            <p className="pg-empty-title">Sem permissão para visualizar usuários</p>
        </div>
    )
}

export default ListSystemUser
